export default __webpack_public_path__ + "static/media/Kannada_cm_1.a0456fec.mp3";